import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'forms/rrf';
import { Button } from 'react-bootstrap';
import { requestReset } from '../../../actions/login';
import TextViewer from '../../common/editor/text-viewer';
import PageTitle from '../../common/page-title';
import LockPopup from '../lock-popup';
import { USER_TYPE_REP, USER_TYPE_RETAILER, USER_TYPE_ADMIN } from '../../../data/userTypes';
import IgniteUkLogo from '../../../assets/img/ignite_logo_black.png';

import './style.css';

const pinRedirectUrl = {
  [USER_TYPE_RETAILER]: '',
  [USER_TYPE_ADMIN]: 'admin',
  [USER_TYPE_REP]: 'team',
};

class ForgottenPasswordForm extends Component {
  state = {
    show: false,
    showBothGivenError: false
  };

  handleSubmit = (payLoad) => {
    const { email, mobile } = payLoad;

    if (email && mobile) {
      this.setState({ showBothGivenError: true });
      return;
    }

    const { dispatch, area } = this.props;

    dispatch(actions.submitFields('deep.resetPW.step1', requestReset(payLoad, `/${pinRedirectUrl[area]}/enter-pin`)
      .catch((error) => {
        dispatch({
          type: 'PW_RESET_VALUE_REJECTED',
          payLoad: error.response.data
        });

        const { errors } = error.response.data;
        const rejectErrors = [];

        if (Object.prototype.toString.call(errors.user) === '[object Array]') {
          errors.user.forEach((curr) => {
            if (curr === 'INVALID_CREDENTIALS') {
              rejectErrors.push({invalid_creds: true});
            }

            if (curr === 'ACCOUNT_LOCKED') {
              rejectErrors.push({locked: true});
              this.setState({show: true});
            }
          });

          return Promise.reject(rejectErrors);
        }

        return Promise.reject(error.response.data.errors);
      })));
  };

  resetErrors = () => {
    const { dispatch } = this.props;

    dispatch(actions.setErrors('deep.resetPW.step1.mobile', { invalid: false }));
    dispatch(actions.setErrors('deep.resetPW.step1.email', { invalid: false }));
    this.setState({ showBothGivenError: false });
  };

  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;

    dispatch(actions.reset('deep.resetPW.step1'));
  }

  render() {
    return (
      <div className="container forgot-password-info user-inner-container">
        <img src={IgniteUkLogo} alt="Ignite UK" />
        <PageTitle>Forgot password</PageTitle>
        <TextViewer pageSlug='request-pin'/>
        <Form
          className="forgot-password-info-form"
          model="deep.resetPW.step1"
          onChange={() => this.resetErrors()}
          onSubmit={values => this.handleSubmit(values)}
        >
          {this.state.showBothGivenError && (
            <div className="errors">
              Please enter either an email address OR mobile number
            </div>
          )}
          <div className="forgot-password-form-element">
            <label htmlFor=".email">
              Email
            </label>
            <Control.text
              className="form-control"
              model=".email"
              type="text"
              validateOn="change"
            />
            <Errors
              className="errors"
              model=".email"
              show={{
                touched: true,
                focus: false
              }}
            />
          </div>
          <div className="forgot-password-form-element">
            <label htmlFor=".mobile">
              Mobile
            </label>
            <Control.text
              className="form-control"
              model=".mobile"
              type="text"
            />
            <Errors
              className="errors"
              model=".mobile"
              show={{
                touched: true,
                focus: false
              }}
            />
          </div>
          <br/>
          <Button
            id="reset-password-btn"
            className="red-btn float-end"
            disabled={(!this.props.enteredEmail && !this.props.enteredMobile) || !this.props.formValid || this.state.showBothGivenError}
            type="submit"
          >
            Reset Password
          </Button>
        </Form>
        {this.state.show && <LockPopup route={`/${pinRedirectUrl[this.props.area]}/login`}/>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.resetPW.step1.$form.valid,
  resetType: state.resetState.type,
  enteredEmail: state.deep.forms.resetPW.step1.email.value,
  enteredMobile: state.deep.forms.resetPW.step1.mobile.value
});

export default connect(mapStateToProps)(ForgottenPasswordForm);
